import { FC } from 'react';
import { SearchPage } from '../SearchPage';
import { Container, Title } from '@mantine/core';
import { Loading, useMedplumProfile } from '@medplum/react';
import { Filter, getReferenceString } from '@medplum/core';
import { HL7 } from '@consts/systems.consts';
import { useNavigate } from 'react-router-dom';
import { getResourceUrl } from '@utils/resource.utils';

// -----------------------------------------------------------------------------
export const TaskSearchPage: FC = () => {
  const profile = useMedplumProfile();
  const navigate = useNavigate();

  // ---------------------------------------------------------------------------
  if (!profile) {
    return <Loading />;
  }

  // ---------------------------------------------------------------------------
  const owner = getReferenceString(profile);
  if (!owner) {
    return <div>No profile</div>;
  }

  // ---------------------------------------------------------------------------
  const now = new Date().toISOString();
  const commonFilters = [
    { code: 'status', operator: 'not', value: 'completed' },
    { code: 'owner', operator: 'eq', value: owner },
  ] as Filter[];

  // ---------------------------------------------------------------------------
  return (
    <Container size={'none'}>
      <Title order={3} pt="md" pl="lg">
        Current Tasks
      </Title>
      <SearchPage
        onResourceClick={(resource) => {
          if (resource.resourceType !== 'Task') {
            return navigate(getResourceUrl(resource));
          }

          const taskUrl = resource.input?.find((input) =>
            input.type?.coding?.some(
              (coding) =>
                coding.system === HL7.TERMINOLOGY.CS.TASK.INPUT_TYPE.BASE &&
                coding.code ===
                  HL7.TERMINOLOGY.CS.TASK.INPUT_TYPE.CODES.TARGET_URL
            )
          )?.valueString;

          if (taskUrl) {
            return navigate(taskUrl);
          }

          return navigate(getResourceUrl(resource));
        }}
        searchRequest={{
          resourceType: 'Task',
          fields: ['subject', 'code', 'status', 'authored-on'],
          sortRules: [{ code: '_lastUpdated', descending: true }],
          filters: [
            ...commonFilters,
            {
              code: '_filter',
              operator: 'eq',
              value: `period pr false or period lt ${now}`,
            },
          ],
        }}
      />

      <Title order={3} pt="md" pl="lg">
        Future Tasks
      </Title>
      <SearchPage
        searchRequest={{
          resourceType: 'Task',
          fields: ['subject', 'code', 'status', 'authored-on'],
          sortRules: [{ code: '_lastUpdated', descending: true }],
          filters: [
            ...commonFilters,
            {
              code: '_filter',
              operator: 'eq',
              value: `period gt ${now}`,
            },
          ],
        }}
      />
    </Container>
  );
};
